import { render, staticRenderFns } from "./VoucherBox.vue?vue&type=template&id=6212f86f&"
import script from "./VoucherBox.vue?vue&type=script&lang=js&"
export * from "./VoucherBox.vue?vue&type=script&lang=js&"
import style0 from "./VoucherBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports